export default __webpack_public_path__ + "media/images/user_photos/123-5557194b397e156396f88c6f37100a91.jpg";